// extracted by mini-css-extract-plugin
export default {"container":"EmptyList_container__8zVnQ","containerImg":"EmptyList_containerImg__I3nOp","description":"EmptyList_description__Hmo1X"};